<template>
    <div class="legenda-container">
        <div v-for="scale in scales" :key="scale.title" class="legenda-row">

            <!-- Title -->
            <div class="legenda-title">{{ scale.title }}</div>

            <!-- Groups -->
            <div class="legenda-groups">
                <div v-for="(label, groupIndex) in scale.labels" :key="label" class="legenda-group">
                    <div class="legenda-cells">
                        <div v-for="index in cellsPerGroup" :key="index"
                            :class="['legenda-cell', fillClasses[groupIndex]]"></div>
                    </div>
                    <div class="legenda-label">{{ label }}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cellsPerGroup: 7,
            fillClasses: ['fill-low', 'fill-medium', 'fill-high'],
            scales: [
                {
                    title: 'Schaal belangen',
                    labels: ['licht gewogen', 'gemiddeld gewogen', 'zwaar gewogen']
                },
                {
                    title: 'Schaal Risicobereidheid',
                    labels: ['behoudend', 'evenwichtig', 'ondernemend']
                }
            ]
        };
    }
}
</script>

<style scoped>
.legenda-container {
    width: 100%;
    padding: 0.4em 0;
    font-size: 13pt;
}

.legenda-row {
    display: flex;
    align-items: flex-start;
    gap: 1em;
    margin-bottom: 1em;
}

.legenda-title {
    flex: 0 0 25%;
    text-align: right;
    font-weight: bold;
    color: #222;
    line-height: 1.4em;
}

.legenda-groups {
    display: flex;
    gap: 0.25em;
}

.legenda-group {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.legenda-cells {
    display: flex;
    gap: 0.25em;
}

.legenda-cell {
    width: 0.9em;
    height: 0.9em;
    border-radius: 0.2em;
}

.legenda-cell.fill-low {
    background: #c9b5e6;
}

.legenda-cell.fill-medium {
    background: #9b77cf;
}

.legenda-cell.fill-high {
    background: #4f2683;
}

.legenda-label {
    margin-top: 0.4em;
    color: #333;
    white-space: nowrap;
    font-size: 80%;
}
</style>
